<template>
  <div class="top-bar">
    <!-- logo -->
    <div class="top-bar__logo">
      <router-link class="logo-link" :to="{ path: '/' }">
        <img src="../assets/logo.png" />
      </router-link>
    </div>
    <!--标题-->
    <div class="top-bar__title">
      <router-link class="title-name" :to="{ path: '/' }">简单笔记</router-link>
    </div>
    <div class="top-bar__nav" v-if="!isAdmin">
      <router-link v-for="item in sections" :key="item.path" class="top-bar__nav-item" :to="{ path: item.path }">
        {{ item.name }}
      </router-link>
    </div>
    <!--其它-->
    <div class="top-bar__extend"></div>

    <!-- 登录菜单 -->
    <div v-if="store.account" class="top-bar__account">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          <el-avatar class="avatar" :src="avatar"></el-avatar>
          <b style="color: #fff">{{ store.account.username }}</b>
          <el-icon class="el-icon--right"><arrow-down /></el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="Edit" command="addArticle">添加文章</el-dropdown-item>
            <el-dropdown-item :icon="User" command="profile">个人信息</el-dropdown-item>
            <el-dropdown-item command="logout" divided>退出</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <div v-else class="top-bar__login">
      <div class="btn-login" @click="handleLogin">
        <i class="fa fa-arrow-circle-o-right"></i>
        登录
      </div>
    </div>
    <UserLogin></UserLogin>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { ArrowDown, User, Edit } from '@element-plus/icons-vue';
  import { ElMessageBox } from 'element-plus';
  import UserLogin from '../components/UserLogin.vue';
  import { userApi, articleApi, sectionApi } from '../api/index.js';
  import { useUserStore } from '@/stores/user';
  import avatar from '@/assets/images/avatar.png';

  const store = useUserStore();

  defineProps({
    isAdmin: {
      type: Boolean,
      default: false
    }
  });

  const handleLogin = () => {
    store.showLogin = true;
  };

  const router = useRouter();
  const handleCommand = async command => {
    switch (command) {
      case 'addArticle': {
        // 这里不能用router.push，否则在编辑页面点击“添加文章”会不跳转
        window.location.href = '/admin/noteadd';
        break;
      }
      case 'profile': {
        router.push({ path: '/mine/profile' });
        break;
      }
      case 'logout': {
        try {
          await ElMessageBox.confirm('确认退出系统吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } catch (e) {
          // 取消
          return;
        }
        const result = await userApi.logout();
        if (result?.errcode === 0) {
          store.sig = null;
          console.log('store.account:', store.account);
          router.push({ path: '/' });
        }
      }
    }
  };
  const sections = ref([]);
  onMounted(async () => {
    const result = await sectionApi.findAll();
    if (result.errcode === 0) {
      sections.value = result.data.map(item => {
        return {
          name: item.title,
          path: `/section_${item.id}`
        };
      });
    }
  });
</script>
<style scoped lang="less">
  /*顶部栏*/
  .top-bar {
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    color: #fff;

    .top-bar__divider {
      display: flex;

      &:before {
        content: ' ';
        border-left: 1px solid #eaeefb;
        height: 12px;
        line-height: 12px;
      }
    }

    .top-bar__logo {
      display: flex;
      width: 55px;
      font-size: 18px;
      font-weight: bold;
      align-items: center;
      justify-content: center;

      .logo-link {
        height: 50px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .top-bar__title {
      display: flex;
      width: 160px;
      font-size: 18px;
      font-weight: bold;

      .title-name {
        color: #fff;
      }
    }

    .top-bar__nav {
      display: flex;
      &-item {
        color: #fff;
        margin-right: 16px;
        font-size: 16px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .top-bar__extend {
      flex: 1;
    }

    .top-bar__account {
      display: flex;
      justify-content: flex-end;
      margin-right: 10px;

      .el-icon--right {
        margin-left: 0 !important;
        color: #fff !important;
      }

      .avatar {
        width: 28px;
        height: 28px;
        border-radius: 100%;
      }

      .el-dropdown-link {
        display: flex;
        align-items: center;
      }
      .el-dropdown-link b {
        padding-left: 8px;
        padding-right: 3px;
      }
    }

    .top-bar__login {
      .btn-login {
        margin-right: 20px;
        color: #ddd;
        &:hover {
          cursor: pointer;
          color: #fff;
        }
      }
    }
  }
</style>
